module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elGoogleQRcode_124279.50561be3.jpg";